<template>
  <div class="high-header">
    <template v-if="device !== 'mobile'">
      <loginSetting></loginSetting>
      <headerSearch></headerSearch>
      <navigatorBar></navigatorBar>
    </template>
    <template v-else>
      <loginSetting :currDevice="device"></loginSetting>
      <mobileCenterComp></mobileCenterComp>
    </template>
  </div>
</template>

<script>
import loginSetting from './loginSetting.vue'
import headerSearch from './headerSearch.vue'
import navigatorBar from './navigatorBar.vue'
import mobileCenterComp from './mobileCenterComp'
import router from '@/router'

export default {
  name: 'high-header',
  computed: {
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        mobile: this.device === 'mobile'
      }
    }
  },
  props: {},
  data() {
    return {}
  },

  components: {
    loginSetting,
    headerSearch,
    navigatorBar,
    mobileCenterComp
  },

  created() {
    this.getUserInfo()
  },

  methods: {
    getUserInfo() {
      this.$store.dispatch('user/getUserInfo').then(res => {
      }).catch(err => {
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.high-header {
  /*min-width: 1200px;*/
  background-color: #fff;

  .mobile {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/high-header.vue